import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { isSuperAdmin } from '@/lib/authorization'

const CITY_CLERK_ADMIN_PATHS = [
  '/city-clerk/members',
  '/city-clerk/roles-and-permissions',
  '/city-clerk/projects',
]

function isAdminPath(pathname: string): boolean {
  return CITY_CLERK_ADMIN_PATHS.some((p) => pathname.startsWith(p))
}

function extractWorkspaceCityIdFromPath(pathname: string): string | null {
  if (isAdminPath(pathname)) return null
  const match = pathname.match(/^\/city-clerk\/([^/]+)(?:\/|$)/)
  return match?.[1] ?? null
}

export const Route = createFileRoute('/(app)/city-clerk/__city-clerk')({
  beforeLoad: ({ context, location }) => {
    if (context.auth.loading) return

    const userInfo = context.auth.userInfo
    if (!userInfo) return

    const superAdmin = isSuperAdmin(userInfo)
    const inAdminSection = isAdminPath(location.pathname)

    if (superAdmin && !inAdminSection) {
      throw redirect({ to: '/superadmin/overview' })
    }

    if (!superAdmin && !inAdminSection) {
      const urlCityId = extractWorkspaceCityIdFromPath(location.pathname)
      const myCityKey = userInfo.cityKey
      if (!myCityKey) {
        throw redirect({ to: '/auth/continue-registration' })
      }
      if (urlCityId && urlCityId !== myCityKey) {
        throw redirect({
          to: '/city-clerk/$id/dashboard',
          params: { id: myCityKey },
          replace: true,
        })
      }
    }
  },
  component: CityClerkLayout,
})

function CityClerkLayout() {
  return <Outlet />
}
